import React, { Component } from 'react';
import './Loading.css';

class Loading extends Component {
  render() {
    return (
      <div className = "Loading">
        <i className = "fa fa-spinner fa-pulse fa-fw" style = {{fontSize: 28 + "px"}}></i>
      </div>
    );
  }
}

export default Loading;
